import React from "react";
import { Field, FieldProps } from "formik";
import Select, { Props as SelectProps } from "react-select";
import CreatableSelect from "react-select/creatable";
import "./LabeledField.scss";

const styles = {
  control: (provided: any, { menuIsOpen, isFocused }: any) => {
    const override =
      menuIsOpen || isFocused
        ? {
            "&:hover": { borderColor: "#636464" },
            borderColor: "#636464",
            boxShadow: "none",
            backgroundColor: "#fff",
            borderRadius: "8px",
          }
        : { backgroundColor: "#fff", borderRadius: "8px" };
    return {
      ...provided,
      ...override,
    };
  },
  option: (provided: any, { isSelected, isFocused }: any) => {
    return {
      ...provided,
      color: "#182722",
      backgroundColor: isSelected ? "#F2F2F2" : isFocused ? "#F2F2F2" : null,
      ":active": { backgroundColor: "#F2F2F2" },
    };
  },
};

/* Helper Component*/
const SelectField = ({
  options,
  field,
  form,
  SelectComponent = Select,
  ...props
}: FieldProps & any) => (
  <SelectComponent
    styles={styles}
    options={options}
    name={field.name}
    value={options ? options.find((option: any) => option.value === field.value) : ""}
    onChange={(option: any) => form.setFieldValue(field.name, option.value)}
    onBlur={field.onBlur}
    {...props}
  />
);

export type LabelSelectProps = {
  label: string;
  onCreateOption?: (inputValue: string) => void;
};

export default function LabeledSelect({
  type = "text",
  label,
  onCreateOption,
  ...rest
}: LabelSelectProps & SelectProps) {
  return (
    <div className="form-group labelField">
      <label>
        <div className="pb-2">{label}</div>
        <Field
          type={type}
          component={SelectField}
          SelectComponent={onCreateOption ? CreatableSelect : Select}
          {...rest}
          onCreateOption={onCreateOption}
        />
      </label>
    </div>
  );
}
